import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var TableToolbar = function TableToolbar(_ref) {
  var className = _ref.className,
    children = _ref.children;
  var wrapperClassNames = classNames('table-toolbar', className && className);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, children);
};
TableToolbar.defaultProps = {};
TableToolbar.propTypes = {
  className: PropTypes.string
};
export default TableToolbar;